import * as ACTION_TYPES from "./action-types";

export const storeAutomations = (automations) => {
  return {
    type: ACTION_TYPES.GET_AUTOMATIONS,
    payload: automations,
  };
};

export const addAutomation = (automation) => {
  return {
    type: ACTION_TYPES.ADD_AUTOMATION,
    payload: automation,
  };
};

export const updateAutomation = (automation) => {
  return {
    type: ACTION_TYPES.UPDATE_AUTOMATION,
    payload: automation,
  };
};

export const updateMultipleAutomations = (automations) => {
  return {
    type: ACTION_TYPES.UPDATE_MULTIPLE_AUTOMATIONS,
    payload: automations,
  };
};

export const updateAutomationTrigger = (trigger) => {
  return {
    type: ACTION_TYPES.UPDATE_AUTOMATION_TRIGGER,
    payload: trigger,
  };
};

export const deleteAutomationTrigger = (triggerId) => {
  return {
    type: ACTION_TYPES.DELETE_AUTOMATION_TRIGGER,
    payload: triggerId,
  };
};

export const deleteAutomation = (automationId) => {
  return {
    type: ACTION_TYPES.DELETE_AUTOMATION,
    payload: automationId,
  };
};

export const setSelectedAutomation = (automation) => {
  return {
    type: ACTION_TYPES.SET_SELECTED_AUTOMATION,
    payload: automation,
  };
};

export const setAutomationSidebarVisible = (visible) => {
  return {
    type: ACTION_TYPES.SET_AUTOMATION_SIDEBAR_VISIBLE,
    payload: visible,
  };
};

export const setTriggerToOpen = (triggerData) => {
  return {
    type: ACTION_TYPES.SET_TRIGGER_TO_OPEN,
    payload: triggerData,
  };
};

export const clearTriggerToOpen = () => {
  return {
    type: ACTION_TYPES.CLEAR_TRIGGER_TO_OPEN,
  };
};
